import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Learn16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.52866 1.91903C8.1936 1.76267 7.80651 1.76267 7.47145 1.91903L1.22947 4.83195C0.237551 5.29485 0.277521 6.71875 1.29383 7.12528L2.75 7.70775V11C2.75 11.1989 2.82902 11.3897 2.96967 11.5303L2.97134 11.532L2.97375 11.5344C3.40624 11.9603 3.90344 12.3212 4.41943 12.6387C5.2926 13.1761 6.55639 13.75 8 13.75C9.42642 13.75 10.6981 13.2283 11.5867 12.736C12.1069 12.4478 12.6201 12.117 13.0678 11.7222L13.0688 11.7213L13.0695 11.7207C13.0695 11.7207 13.3213 11.5 13.3213 11.1453L13.2542 7.70612L13.75 7.50779V9.5C13.75 9.91421 14.0858 10.25 14.5 10.25C14.9142 10.25 15.25 9.91421 15.25 9.5V6.70999C15.6868 6.11731 15.5355 5.1889 14.7706 4.83195L8.52866 1.91903ZM2.38708 5.94703L8.00006 3.32764L13.613 5.94703L8.00006 8.19222L2.38708 5.94703ZM11.7655 8.30159L8.46429 9.62207C8.16628 9.74128 7.83383 9.74128 7.53582 9.62207L4.25 8.30775V10.6677C5.28783 11.5536 6.6066 12.25 8 12.25C9.39393 12.25 10.7168 11.6251 11.8144 10.8059L11.7655 8.30159Z'
      fill='currentColor'
    />
  </Svg>
);

Learn16.displayName = 'Learn16';
export default Learn16;
